import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Flex, theme, Grid } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import { track } from "./../../../lib/gtag.js";
import { NAVIGATION_EVENTS } from "./../../../lib/gtagService.js";
const { useBreakpoint } = Grid;
const NavMenu = ({ menuItems, drawerOpened }) => {
  const { token } = theme.useToken();
  const location = useLocation();
  const screens = useBreakpoint();
  const [current, setCurrent] = useState(location.pathname.replace("/", ""));
  useEffect(() => {
    setCurrent(location.pathname.replace("/", ""));
  }, [location.pathname]);
  const onClick = (key) => {
    setCurrent(key);
    NAVIGATION_EVENTS[key] && track(NAVIGATION_EVENTS[key]);
  };
  const mobileStyle = !screens.lg ? {
    position: "fixed",
    backgroundColor: token.colorBgBase,
    bottom: "env(safe-area-inset-bottom, 0)",
    left: 0,
    zIndex: 99,
    width: "calc(100% - 30px)",
    height: drawerOpened ? 0 : "unset",
    overflow: "hidden",
    justifyContent: menuItems.length < 5 ? "space-around" : "space-between",
    padding: 0,
    borderRadius: "8px 8px 0 0",
    margin: "0 15px"
  } : {};
  return /* @__PURE__ */ jsx(
    Flex,
    {
      className: `app-header_menu ${!screens.lg ? "mobile" : "desktop"}`,
      align: "center",
      gap: !screens.lg ? 0 : 40,
      style: mobileStyle,
      children: menuItems.map((menuItem, index) => {
        const itemIsActive = menuItem.key === current.split("/")[0];
        return /* @__PURE__ */ jsx(
          NavLink,
          {
            to: menuItem.to,
            className: `app-header_menu_item ${itemIsActive ? "active" : ""}`,
            onClick: () => onClick(menuItem.key),
            children: /* @__PURE__ */ jsxs(
              Flex,
              {
                gap: 8,
                align: "center",
                style: { height: "100%" },
                className: "app-header_menu_item_container",
                children: [
                  /* @__PURE__ */ jsx(Flex, { className: "app-header_menu_item_icon", children: itemIsActive ? menuItem.activeIcon : menuItem.icon }),
                  /* @__PURE__ */ jsx(
                    Flex,
                    {
                      style: {
                        textTransform: "uppercase",
                        fontSize: token.fontSizeLG,
                        fontWeight: 500
                      },
                      className: "app-header_menu_item_label",
                      children: menuItem.label
                    }
                  )
                ]
              }
            )
          },
          menuItem.key
        );
      })
    }
  );
};
var stdin_default = NavMenu;
export {
  stdin_default as default
};
